import { CHATWOOT_KEY } from "../../constants";
import CryptoJS from "crypto-js";

export const setChatwootUser = (user, number) => {
    const { user_cloud_id, image_url, contact, phone_number } = user || {};

    const message = `${phone_number || number || 'anonymous'}`;
    const hash = CryptoJS.HmacSHA256(message, CHATWOOT_KEY).toString(CryptoJS.enc.Hex);

    window.$chatwoot.setUser(phone_number || number || 'anonymous', {
        email: `${phone_number || number || 'anonymous'}@udhaar.pk`,
        name: contact || 'anonymous',
        avatar_url: image_url || null,
        phone_number: phone_number || number || 'anonymous',
        identifier_hash: hash,
    });
}